"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.experimental = void 0;
var settings = {};
var experimental = {
  has: function has(name) {
    return name in settings;
  },
  get: function get(name) {
    return settings[name];
  },
  apply: function apply(next) {
    settings = next;
  },
  clear: function clear() {
    settings = {};
  },
  snapshot: function snapshot() {
    return settings;
  },
  // Boundary: SSR. Reads `experimentalSettings` off the JSON body PHP sends Node.
  fromResponseBody: function fromResponseBody(body) {
    var _ref;

    return (_ref = body.experimentalSettings) !== null && _ref !== void 0 ? _ref : {};
  },
  // Boundary: browser bootstrap. Reads `data-experimental-settings` JSON off the
  // preact-app hydration script tag.
  fromScriptAttribute: function fromScriptAttribute(el) {
    var _el$getAttribute;

    return JSON.parse((_el$getAttribute = el === null || el === void 0 ? void 0 : el.getAttribute('data-experimental-settings')) !== null && _el$getAttribute !== void 0 ? _el$getAttribute : '{}');
  }
};
exports.experimental = experimental;